import "./section";
import "./seat";
import "./unnumberedSeat";

function requireAll(r) {
  r.keys().forEach(r);
}

requireAll(require.context("./plugins/", true, /\.js$/));
